import React, { FC } from "react";
import { OverlayView, OverlayViewF } from "@react-google-maps/api";
import { MarkerData } from "./types";
import { MarkerBlip, MarkerLabel } from "../../Map.styled";
import { useTranslation } from "react-i18next";

interface MarkerTooltipProps {
  marker: MarkerData;
}

const MarkerTooltip: FC<MarkerTooltipProps> = ({ marker }) => {
  const { t } = useTranslation();
  const label = marker.isInactive
    ? `${marker?.name || "N/A"} · ${t("common.inactive")}`
    : marker?.name || "N/A";

  return (
    <OverlayViewF
      position={{ lat: marker.lat, lng: marker.lng }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={() => ({ x: 20, y: -33 })}
    >
      <>
        <MarkerLabel title={label}>{label}</MarkerLabel>
        <MarkerBlip></MarkerBlip>
      </>
    </OverlayViewF>
  );
};

export default React.memo(MarkerTooltip);
